<template>
  <div class="flex flex-col items-center p-4 bg-white border-2 rounded">
    <img :src="product.photo" width="100" height="100" alt="Producto" />
    <h3 class="text-lg font-medium">{{ product.name }} </h3>
    <p class="text-gray-500 text-xs">{{ product.code }}</p>
    <p class="text-gray-500">${{ (product?.prices[0]['price']).toFixed(2) }}</p>
    <p class="text-gray-500">BsD.{{ (product?.prices[0]['price'] * change).toFixed(2) }}</p>
    <p class="text-gray-500">COP {{ formatNumberCop(product?.price_cop > 0 ? product.price_cop : (product?.prices[0]['price'] * cop_change)) }}</p>
    <p class="text-gray-500 text-xs mb-2">
      <span :class="product?.quantity > 0 ? 'text-emerald-700 font-bold' : 'text-red-500 font-bold'">
        {{ product?.quantity }} disponibles
      </span>
    </p>
    <button 
      @click="addProduct(product)" 
      :disabled="product?.quantity <= 0"
      :class="product?.quantity > 0 ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer' : 'bg-gray-200 text-gray-500 cursor-not-allowed'"
      class="px-4 py-2 font-bold rounded transition-colors text-xs w-full"
    >
      {{ product?.quantity > 0 ? 'Agregar al carrito' : 'Agotado' }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    product: Object,
    change: Number,
    cop_change: Number
  },
  methods: {
    addProduct(product)
    {
        this.$emit('addCart', product);
    },
    formatNumberCop(val) {
      const rounded = Math.round((val || 0) / 100) * 100
      return new Intl.NumberFormat('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(rounded)
    }
  }
}
</script>
